import React, { useCallback } from 'react';
import { DropdownMenuTrigger } from './view';

export type ToggleMenu = (isOpen: boolean, ref?: HTMLButtonElement) => void;

export interface MenuToggleButtonProps {
    children: React.ReactNode;
    ref?: React.Ref<HTMLButtonElement>;
    className?: string;
}

export const MenuToggleButton = ({ children, className, ref }: MenuToggleButtonProps) => {
    const handleClick = useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
    }, []);

    return (
        <DropdownMenuTrigger
            ref={ref}
            asChild
        >
            <div
                className={className}
                onClick={handleClick}
            >
                {children}
            </div>
        </DropdownMenuTrigger>
    );
};
